// Plyta.jsx
import React from 'react';
import { useGLTF, useTexture } from '@react-three/drei';
import { cloneAndScaleUV } from '../../utils/geometryUltis';
import * as THREE from 'three';

export default function Plyta({ length, width, anchoring, position = [0, 0.05, 0], ...props }) {
  const { nodes } = useGLTF('/models/testy/garaz-płyta.glb');

  const scaledPlytaGeometry = React.useMemo(() => {
    let addition = 0;

    if (anchoring === 3) {
      addition = 10;
    }

    const g = cloneAndScaleUV(
      nodes.plyta.geometry,
      length / 10 - 0.1 + addition,
      3,
      width / 10 - 0.1 + addition,
      length / 100 - 0.1 + addition,
      width / 100 - 0.1 + addition
    );

    // AO wymaga uv2 – jeśli nie ma, skopiuj uv
    if (!g.attributes.uv2 && g.attributes.uv) {
      g.setAttribute('uv2', g.attributes.uv);
    }
    return g;
  }, [length, width, anchoring, nodes.plyta.geometry]);

  const { map, arm, normalMap } = useTexture({
    map: 'textures/concrete/damaged_concrete_floor_02_diff_1k.jpg',
    arm: 'textures/concrete/damaged_concrete_floor_02_arm_1k.jpg',
    normalMap: 'textures/concrete/damaged_concrete_floor_02_nor_gl_1k.jpg'
  });

  React.useMemo(() => {
    [map, arm, normalMap].forEach((tex) => {
      tex.flipY = false;
      tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
      tex.anisotropy = 8;
    });
    map.colorSpace = THREE.SRGBColorSpace;
    arm.colorSpace = THREE.NoColorSpace;
    return null;
  }, [map, arm, normalMap]);

  return (
    <group {...props} dispose={null} position={position}>
      <mesh geometry={scaledPlytaGeometry} receiveShadow castShadow>
        <meshStandardMaterial
          map={map}
          normalMap={normalMap}
          aoMap={arm}
          roughnessMap={arm}
          metalnessMap={arm}
          roughness={1}
          metalness={0}
          aoMapIntensity={1}
          normalScale={new THREE.Vector2(0.7, 0.7)}
          color={[0.9, 0.9, 0.9]}
        />
      </mesh>
    </group>
  );
}

useGLTF.preload('/models/testy/garaz-płyta.glb');
